<template>
  <div class="col-md-12">
    <barra-navegacao :visiblebutton="true"/>

    <div class="container-solicitacao">
      <b-card class="card-formulario" bg-variant="light" style="box-shadow: 2px 2px 8px rgba(0,0,0,0.15);">
        <h4 class="mb-4"><b-icon icon="clipboard-plus" class="mr-2"></b-icon>{{ idSolicitacaoEdit ? `Adicionar ${tipoSolicitacao === 'INVENTARIO' ? 'Inventários' : 'Checklists'} na Solicitação` : `Nova Solicitação de ${tipoSolicitacao === 'INVENTARIO' ? 'Inventário' : 'Checklist'}` }}</h4>

        <!-- Info da Solicitação no Modo Edição -->
        <b-alert show variant="info" v-if="idSolicitacaoEdit && solicitacaoAtual" class="mb-4">
          <b-icon icon="info-circle" class="mr-2"></b-icon>
          <strong>Solicitação #{{ solicitacaoAtual.idSolicitacao }}</strong> - {{ solicitacaoAtual.descricao || 'Sem descrição' }}
        </b-alert>

        <!-- Periodo e Descricao -->
        <b-row class="mb-3">
          <b-col md="3">
            <label class="font-weight-bold">Período Letivo</label>
            <b-form-input :value="periodoLetivo" disabled></b-form-input>
          </b-col>
          <b-col md="9">
            <label class="font-weight-bold">Descrição</label>
            <b-form-textarea
              v-model="descricao"
              rows="3"
              max-rows="6"
              placeholder="Descreva o objetivo desta solicitação..."
            ></b-form-textarea>
          </b-col>
        </b-row>

        <!-- Todos os Locais -->
        <b-row class="mb-4 align-items-center">
          <b-col md="4" v-if="!idSolicitacaoEdit">
            <label class="font-weight-bold d-block">Abrange todos os locais?</label>
            <toggle-button
              v-model="todosLocais"
              :labels="{checked: 'Sim', unchecked: 'Nao'}"
              :color="{checked: '#28a745', unchecked: '#6c757d'}"
              :width="70"
              :sync="true"
            />
          </b-col>
        </b-row>

        <!-- Listagem de Locais (quando todosLocais = false) -->
        <div v-if="!todosLocais || idSolicitacaoEdit">
          <hr>
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="mb-0">
              <b-icon icon="geo-alt" class="mr-1"></b-icon>
              Selecione os Locais
              <b-badge variant="info" class="ml-2">{{ locaisSelecionados.length }} selecionado(s)</b-badge>
              <b-badge v-if="tipoSolicitacao === 'INVENTARIO'" variant="warning" class="ml-2">Exibindo apenas locais sem inventário ativo</b-badge>
            </h6>
            <b-form-input
              v-model="filtroLocais"
              placeholder="Filtrar locais..."
              size="sm"
              style="max-width: 250px;"
              id="filtro-locais"
            ></b-form-input>
          </div>

          <div v-if="carregandoLocais" class="text-center py-3">
            <b-spinner variant="primary" small></b-spinner>
            <span class="ml-2 text-muted">Carregando locais...</span>
          </div>

          <div v-else-if="locaisFiltrados.length === 0" class="text-center py-4 text-muted">
            <b-icon icon="inbox" font-scale="2"></b-icon>
            <p class="mt-2">
              <span v-if="tipoSolicitacao === 'INVENTARIO'">Todos os locais já possuem inventário ativo neste período.</span>
              <span v-else>Nenhum local ativo encontrado.</span>
            </p>
          </div>

          <b-table stacked="md"
            v-else
            :items="locaisFiltrados"
            :fields="fieldsLocais"
            small
            hover
            bordered
            responsive
            class="tabela-locais"
            id="tabela-locais"
          >
            <template v-slot:cell(selecionar)="data">
              <b-form-checkbox
                v-model="locaisSelecionados"
                :value="data.item"
                :id="`check-local-${data.index}`"
              ></b-form-checkbox>
            </template>
            <template v-slot:cell(local)="data">
              <span>{{ data.item.descricao }}</span>
            </template>
            <template v-slot:cell(tipo)="data">
              <b-badge :variant="data.item.idSala ? 'info' : 'secondary'">
                {{ data.item.idSala ? 'Sala' : 'Andar Inteiro' }}
              </b-badge>
            </template>
          </b-table>

          <!-- Selecionar Todos -->
          <div class="mt-2 mb-3" v-if="locaisFiltrados.length > 0">
            <b-button size="sm" variant="outline-primary" @click="selecionarTodosLocais" id="btn-selecionar-todos">
              <b-icon icon="check-all"></b-icon> Selecionar Todos
            </b-button>
            <b-button size="sm" variant="outline-secondary" class="ml-2" @click="limparSelecao" id="btn-limpar-selecao">
              <b-icon icon="x"></b-icon> Limpar Selecao
            </b-button>
          </div>
        </div>
      </b-card>
      <br>
      <b-card bg-variant="light">
        <!-- Botoes -->
        <div class="d-flex justify-content-end">
          
          <b-button
            style="background-color: #303f9f; color: white; border: none;"
            @click="criarSolicitacao"
            :disabled="!podeCriar"
            id="btn-criar-solicitacao"
            size="sm">
            <b-icon icon="check-circle"></b-icon> {{ idSolicitacaoEdit ? `Adicionar ${tipoSolicitacao === 'INVENTARIO' ? 'Inventários' : 'Checklists'}` : 'Criar Solicitação' }}
          </b-button>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import BarraNavegacao from '../../components/BarraNavegacao.vue';
import SolicitacaoService from '../../services/SolicitacaoService';
import ParametroService from '../../services/ParametroService';

export default {
  name: 'NovaSolicitacao',
  components: { BarraNavegacao },
  data() {
    return {
      idSolicitacaoEdit: null,
      solicitacaoAtual: null,
      periodoLetivo: '',
      descricao: '',
      tipoSolicitacao: 'INVENTARIO',
      todosLocais: false,

      locaisDisponiveis: [],
      locaisSelecionados: [],
      filtroLocais: '',
      carregandoLocais: false,

      fieldsLocais: [
        { key: 'selecionar', label: '', class: 'text-center', thStyle: { width: '50px' } },
        { key: 'local', label: 'Local' },
        { key: 'tipo', label: 'Tipo', class: 'text-center' }
      ]
    };
  },
  computed: {
    podeCriar() {
      if (!this.periodoLetivo) return false;
      if ((!this.todosLocais || this.idSolicitacaoEdit) && this.locaisSelecionados.length === 0 && !this.descricao.trim()) return false;
      return true;
    },
    locaisFiltrados() {
      if (!this.filtroLocais) return this.locaisDisponiveis;
      const f = this.filtroLocais.toLowerCase();
      return this.locaisDisponiveis.filter(l => l.descricao.toLowerCase().includes(f));
    }
  },
  created() {
    this.inicializarComponente();
  },
  watch: {
    $route() {
      this.inicializarComponente();
    },
    todosLocais(novoValor) {
      if (!novoValor) {
        this.locaisSelecionados = [];
        this.carregarLocais();
      }
    }
  },
  methods: {
    inicializarComponente() {
      this.carregarPeriodo();
      if (this.$route.query.id) {
        this.idSolicitacaoEdit = parseInt(this.$route.query.id);
        this.todosLocais = false;
        SolicitacaoService.buscarPorId(this.idSolicitacaoEdit).then(res => {
          if (res.data && res.data.solicitacao) {
            this.solicitacaoAtual = res.data.solicitacao;
            this.descricao = res.data.solicitacao.descricao || '';
            this.periodoLetivo = res.data.solicitacao.periodoLetivo;
            if (res.data.solicitacao.tipo) {
              this.tipoSolicitacao = res.data.solicitacao.tipo;
            }
          }
        });
        this.carregarLocais();
      } else {
        this.idSolicitacaoEdit = null;
        this.solicitacaoAtual = null;
        this.descricao = '';
        this.locaisSelecionados = [];
        if (this.$route.meta && this.$route.meta.tipo) {
          this.tipoSolicitacao = this.$route.meta.tipo;
        }
        if (!this.todosLocais) {
          this.carregarLocais();
        }
      }
    },
    alertaMensager(mensagem, titulo, tipo) {
      return this.$fire({ title: titulo, text: mensagem, type: tipo });
    },
    alertaMensagerHtml(mensagem, titulo, tipo) {
      return this.$fire({ title: titulo, html: mensagem, type: tipo });
    },
    formatarIgnorados(ignorados) {
      if (!ignorados || ignorados.length === 0) return '';
      const nomes = ignorados.map(cl => {
        const loc = this.locaisDisponiveis.find(l => 
          l.idBloco === cl.idBloco && 
          l.idAndar === cl.idAndar && 
          (l.idCorredor === cl.idCorredor || (!l.idCorredor && !cl.idCorredor)) &&
          (l.idSala === cl.idSala || (!l.idSala && !cl.idSala))
        );
        if (loc) return loc.descricao;
        
        let fallback = `Bloco ${cl.idBloco} - Andar ${cl.idAndar}`;
        if (cl.idCorredor) fallback += ` - Corredor ${cl.idCorredor}`;
        if (cl.idSala) fallback += ` - Sala ${cl.idSala}`;
        return fallback;
      });
      return `<ul class="text-left" style="margin-top: 10px; font-size: 14px;"><li>${nomes.join('</li><li>')}</li></ul>`;
    },

    carregarPeriodo() {
      ParametroService.listarTodos().then(res => {
        const param = res.data.find(p => p.identificador === 'PERIODO_LETIVO');
        if (param) this.periodoLetivo = param.valor;
      }).catch(() => {
        this.alertaMensager('Nao foi possivel carregar o periodo letivo.', 'Atencao', 'warning');
      });
    },

    carregarLocais() {
      this.carregandoLocais = true;
      this.locaisDisponiveis = [];

      this.$http.get('/bloco').then(resBlocos => {
        const blocos = resBlocos.data.filter(b => b.status === 'A');
        const promises = blocos.map(bloco =>
          this.$http.get(`/andar/bloco?id_bloco=${bloco.idBloco}`).then(resAndares => {
            const andares = resAndares.data.filter(a => a.status === 'A');
            const subPromises = andares.map(andar => {
              return this.$http.get(`/andar-corredores/bloco/${bloco.idBloco}/andar/${andar.idAndar}`).then(resCorredores => {
                const corredores = resCorredores.data;
                const locaisAndar = [];
                // Add the whole Andar
                locaisAndar.push({
                  idBloco: bloco.idBloco,
                  idAndar: andar.idAndar,
                  idCorredor: null,
                  idSala: null,
                  descricao: `${bloco.descricao} - ${andar.descricao} (Andar Inteiro)`
                });

                const corrPromises = corredores.map(corredorModel => {
                  const corredor = corredorModel.corredor;
                  if (!corredor) return [];
                  
                  return this.$http.get(`/corredor-salas/bloco/${bloco.idBloco}/andar/${andar.idAndar}/corredor/${corredor.idCorredor}`).then(resSalas => {
                    const salas = resSalas.data;
                    const locaisCorredor = [];
                    // Add the whole Corredor
                    locaisCorredor.push({
                      idBloco: bloco.idBloco,
                      idAndar: andar.idAndar,
                      idCorredor: corredor.idCorredor,
                      idSala: null,
                      descricao: `${bloco.descricao} - ${andar.descricao} - ${corredor.descricao} (Corredor Inteiro)`
                    });
                    
                    if (salas.length > 0) {
                      salas.forEach(salaModel => {
                        const sala = salaModel.sala;
                        if(sala) {
                            locaisCorredor.push({
                            idBloco: bloco.idBloco,
                            idAndar: andar.idAndar,
                            idCorredor: corredor.idCorredor,
                            idSala: sala.idSala,
                            descricao: `${bloco.descricao} - ${andar.descricao} - ${corredor.descricao} - ${sala.descricaoCompleta}`
                            });
                        }
                      });
                    }
                    return locaisCorredor;
                  }).catch(() => []);
                });
                
                return Promise.all(corrPromises).then(res => {
                    return locaisAndar.concat(res.flat());
                });
              }).catch(() => []);
            });
            return Promise.all(subPromises).then(resultados => resultados.flat());
          }).catch(() => [])
        );
        return Promise.all(promises).then(resultados => resultados.flat());
      }).then(todosLocais => {
        if (this.tipoSolicitacao === 'INVENTARIO' && this.periodoLetivo) {
          const filterPromises = todosLocais.map(local => {
            let url = `/checklist/ultimo-por-local?bloco=${local.idBloco}&andar=${local.idAndar}`;
            if (local.idCorredor) url += `&corredor=${local.idCorredor}`;
            if (local.idSala) url += `&sala=${local.idSala}`;
            return this.$http.get(url).then(res => {
              const cl = res.data;
              if (cl && cl.ancora === true && cl.status !== 'Can') return null;
              return local;
            }).catch(() => local);
          });
          return Promise.all(filterPromises).then(results => results.filter(l => l !== null));
        }
        return todosLocais;
      }).then(locaisFiltrados => {
        this.locaisDisponiveis = locaisFiltrados;
      }).catch(() => {
        this.alertaMensager('Erro ao carregar locais.', 'Erro', 'error');
      }).finally(() => {
        this.carregandoLocais = false;
      });
    },

    selecionarTodosLocais() {
      this.locaisSelecionados = [...this.locaisFiltrados];
    },

    limparSelecao() {
      this.locaisSelecionados = [];
    },

    voltar() {
      const rotaBase = this.tipoSolicitacao === 'INVENTARIO' ? '/solicitacao/inventario/lista' : '/solicitacao/checklist/lista';
      if (this.idSolicitacaoEdit) {
        this.$router.push({ path: rotaBase, query: { id: this.idSolicitacaoEdit } }).catch(()=>{});
      } else {
        this.$router.push(rotaBase).catch(()=>{});
      }
    },

    criarSolicitacao() {
      if (!this.podeCriar) return;

      const locaisPayload = this.locaisSelecionados.map(l => ({
        idBloco: l.idBloco,
        idAndar: l.idAndar,
        idCorredor: l.idCorredor || null,
        idSala: l.idSala || null
      }));

      this.$loading(true);

      if (this.idSolicitacaoEdit) {
        const payload = {
          descricao: this.descricao,
          locaisEspecificos: locaisPayload
        };
        SolicitacaoService.adicionarChecklists(this.idSolicitacaoEdit, payload).then((res) => {
          const ignorados = res.data && res.data.checklistsIgnorados ? res.data.checklistsIgnorados : [];
          if (ignorados.length > 0) {
            this.alertaMensagerHtml(
              `A solicitação foi atualizada, porém os seguintes locais já possuíam registro ativo e foram ignorados: ${this.formatarIgnorados(ignorados)}`,
              'Atenção',
              'warning'
            ).then(() => {
              this.voltar();
            });
          } else {
            this.$bvToast.toast('Solicitação atualizada com sucesso!', { variant: 'success', solid: true, autoHideDelay: 4000, title: 'Sucesso' });
            this.voltar();
          }
        }).catch(err => {
          const msg = err.response && err.response.data ? err.response.data : 'Erro ao atualizar solicitação.';
          this.alertaMensager(msg, 'Erro', 'error');
        }).finally(() => {
          this.$loading(false);
        });
        return;
      }

      const payload = {
        descricao: this.descricao,
        periodoLetivo: this.periodoLetivo,
        todosLocais: this.todosLocais,
        tipo: this.tipoSolicitacao,
        locaisEspecificos: this.todosLocais ? null : locaisPayload
      };

      SolicitacaoService.criar(payload).then(res => {
        if (res.status === 203 || (res.data && !res.data.solicitacao)) {
          const ignorados = res.data && res.data.checklistsIgnorados ? res.data.checklistsIgnorados : [];
          this.alertaMensagerHtml(
            `Nenhum local foi adicionado pois todos os locais selecionados já possuem registro ativo: ${this.formatarIgnorados(ignorados)}`,
            'Atenção',
            'warning'
          );
        } else {
          const ignorados = res.data && res.data.checklistsIgnorados ? res.data.checklistsIgnorados : [];
          if (ignorados.length > 0) {
            this.alertaMensagerHtml(
              `Solicitação criada! Porém, os seguintes locais já possuíam registro ativo e foram ignorados: ${this.formatarIgnorados(ignorados)}`,
              'Atenção',
              'warning'
            ).then(() => {
              this.voltar();
            });
          } else {
            this.$bvToast.toast('Solicitação criada com sucesso!', { variant: 'success', solid: true, autoHideDelay: 4000, title: 'Sucesso' });
            this.voltar();
          }
        }
      }).catch(err => {
        console.error(err);
        this.alertaMensager('Erro ao criar solicitação.', 'Erro', 'error');
      }).finally(() => {
        this.$loading(false);
      });
    }
  }
};
</script>

<style scoped>
.container-solicitacao {
  padding: 10px 0;
}
.tabela-locais {
  max-height: 400px;
  overflow-y: auto;
}
</style>
